import React, { useState } from "react";
import GooglePlacesAutocomplete, {
  geocodeByPlaceId,
} from "react-google-places-autocomplete";
import { Button, Form, Input, notification } from "antd";
import { ArrowLeftOutlined, EnvironmentOutlined } from "@ant-design/icons";
import DataProvider from "../../../services";

const placesSelectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    minHeight: 40,
    borderRadius: 8,
    borderColor: state.isFocused ? "#06509E" : "#d9d9d9",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(6,80,158,0.15)" : "none",
    "&:hover": { borderColor: "#06509E" },
  }),
  option: (base: any, state: any) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#06509E"
      : state.isFocused
        ? "#06509E1a"
        : "white",
    color: state.isSelected ? "white" : "#171717",
  }),
};

type Geo = {
  lat: number | null;
  lng: number | null;
  town: string | null;
};
export default function AddAddress(props: any) {
  const [api, contextHolder] = notification.useNotification();
  const [form] = Form.useForm();
  const [value, setValue] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [geo, setGeo] = useState<Geo>({
    lat: null,
    lng: null,
    town: null,
  });

  async function handleChange(newValue: any, actionMeta: any) {
    setValue(newValue);
    if (newValue) {
      await geocodeByPlaceId(newValue.value.place_id)
        .then((results) => {
          // Extract the latitude and longitude from the results
          const { lat, lng } = results[0].geometry.location;
          setGeo({
            lat: lat(),
            lng: lng(),
            town: newValue.value.description,
          });
        })
        .catch((error) => console.error(error));
    }
  }

  async function onSubmit() {
    const values = await form.getFieldsValue();
    if (!values.label) {
      return api["warning"]({
        message: "Label",
        description: "Add a label, E.g. Home, Work, School, etc...",
      });
    }

    if (!values.landmark) {
      return api["warning"]({
        message: "Landmark",
        description: "Add a landmark, E.g. American House Building",
      });
    }

    if (!geo.lat || !geo.lng || !geo.town) {
      return api["warning"]({
        message: "Address",
        description: "Select your location",
      });
    }

    const payload = {
      label: values.label,
      landmark: values.landmark,
      town: geo.town,
      geoCode: `${geo.lat}, ${geo.lng}`,
    };
    try {
      setLoading(true);
      await DataProvider.addAddress(payload);
      setLoading(false);
      api["success"]({
        message: "Success",
        description: "Address created successfully!",
      });
      props.setInnerTab(null);
    } catch (error: any) {
      setLoading(false);
      api["error"]({
        message: "Error",
        description: error.message,
      });
    }
  }

  return (
    <div className="w-full flex justify-center px-1">
      <div className="lg:w-[40%] md:w-[70%] w-full rounded-lg">
        <button
          type="button"
          onClick={() => props.setInnerTab(null)}
          className="inline-flex items-center gap-2 text-sm font-medium text-neutral-600 hover:text-neutral-900 mb-4 transition-colors"
        >
          <ArrowLeftOutlined />
          Back
        </button>
        <div className="mb-5">
          <h3 className="font-semibold text-lg text-neutral-900">
            Add a new address
          </h3>
          <p className="text-sm text-neutral-500 mt-0.5">
            This is where your medication orders will be delivered.
          </p>
        </div>
        <div className="rounded-xl border border-neutral-200 p-4 sm:p-5">
          <Form form={form} name="basic" layout="vertical" autoComplete="off">
            <Form.Item name="label" label="Label" className="">
              <Input
                size="large"
                placeholder="Label (E.g. Home, Work, School, etc...)"
              />
            </Form.Item>
            <Form.Item name="landmark" label="Landmark" className="-mt-2">
              <Input
                size="large"
                placeholder="Landmark (E.g. American House Building)"
              />
            </Form.Item>
          </Form>
          <label className="block text-sm font-medium text-neutral-800 mb-2">
            <EnvironmentOutlined className="mr-1" />
            Search your address
          </label>
          <GooglePlacesAutocomplete
            apiKey="AIzaSyAhgtfJxTiH2FHISEj_u7EI_FDKQY4yuag"
            apiOptions={{
              apiKey: "AIzaSyAhgtfJxTiH2FHISEj_u7EI_FDKQY4yuag",
              region: "gh",
              language: "en",
              libraries: ["geocoding", "places", "geometry", "maps"],
            }}
            selectProps={{
              value,
              onChange: (newValue: any, actionMeta: any) =>
                handleChange(newValue, actionMeta),
              placeholder: "Enter your address",
              backspaceRemovesValue: true,
              isClearable: true,
              styles: placesSelectStyles,
            }}
            autocompletionRequest={{
              types: ["establishment", "geocode"],
              componentRestrictions: {
                country: "gh",
              },
            }}
          />
        </div>
        <div className="my-5 w-full flex flex-col justify-center items-center">
          <Button
            onClick={onSubmit}
            type="primary"
            size="large"
            loading={loading}
            style={{ backgroundColor: "#06509E" }}
            className="flex justify-center items-center w-full"
          >
            {loading ? "Saving..." : "Save Address"}
          </Button>
          <Button
            onClick={() => props.setInnerTab(null)}
            size="large"
            disabled={loading}
            className="flex justify-center items-center w-full mt-3"
          >
            Cancel
          </Button>
        </div>
      </div>
      {contextHolder}
    </div>
  );
}
